export const TAB_RETURN_RECHECK_MS = 5 * 60 * 1000

export const shouldRecheckOnTabReturn = ({
  visibilityState,
  nowMs,
  lastCheckAtMs,
  minIntervalMs = TAB_RETURN_RECHECK_MS
}: {
  visibilityState: string
  nowMs: number
  lastCheckAtMs: number | null
  minIntervalMs?: number
}): boolean => {
  if (visibilityState !== 'visible') return false
  if (lastCheckAtMs == null) return true
  const elapsed = nowMs - lastCheckAtMs
  return elapsed < 0 || elapsed >= minIntervalMs
}

export const handleTabReturn = ({
  enabled,
  recheck,
  minIntervalMs,
  lastCheckAtRef,
  visibilityState,
  nowMs
}: {
  enabled: boolean
  recheck: () => void
  minIntervalMs: number
  lastCheckAtRef: { current: number | null }
  visibilityState: string
  nowMs: number
}): boolean => {
  if (!enabled) return false
  const due = shouldRecheckOnTabReturn({
    visibilityState,
    nowMs,
    lastCheckAtMs: lastCheckAtRef.current,
    minIntervalMs
  })
  if (!due) return false
  lastCheckAtRef.current = nowMs
  recheck()
  return true
}
